import { render } from "./ColorDropdown.vue?vue&type=template&id=f84b8286&scoped=true"
import script from "./ColorDropdown.vue?vue&type=script&lang=js"
export * from "./ColorDropdown.vue?vue&type=script&lang=js"

import "./ColorDropdown.vue?vue&type=style&index=0&id=f84b8286&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84b8286"]])

export default __exports__